import { FusionError, Import, RImport, safeParseJson, safeUnparseJson, serializeFusionError } from '@fusion-advantage/backcompat'
import { draftImportApplyPrevImport, SyncDeviceToCloudOrdinalsStatus } from "@fusion-advantage/formlib"
import { err, ok, Result } from "neverthrow"
import { AppThunk } from "../redux/appStore"
import { selectWritesDisabled } from "../redux/selectWritesDisabled"
import { dashboardDataReloadFromLdb } from "../redux/dashboardDataSlice"
import { deleteDeviceToCloudBlob, DeviceToCloudBlobType, insertDeviceToCloudBlob, selectLatestDeviceToCloudBlob } from "../dal/ldbDeviceToCloudBlob"

export const updateWorkItemImport = (upn: string, encounterGuid: string, imp: Import): AppThunk<Promise<Result<void, FusionError>>> => async (dispatch, getState) => {
	if(selectWritesDisabled(getState())) {
		return ok()
	}
	// patch the import with latest unsynced import
	const rSelectImport = await selectLatestDeviceToCloudBlob(
		{
			type: DeviceToCloudBlobType.Import,
			encounterGuid,
			fileId: null,
			upn,
		},
	)
	if(rSelectImport.isErr()) {
		return err(serializeFusionError('updateWorkItemImport', rSelectImport.error))
	}
	if(rSelectImport.value) {
		const prevImpBlob = rSelectImport.value
		const rParse = safeParseJson(prevImpBlob.data, RImport)
		if(rParse.isErr()) {
			return err(serializeFusionError('updateWorkItemImport', rParse.error))
		}
		const prevImp = rParse.value
		imp = draftImportApplyPrevImport(imp, prevImp)
	}
	// 20260428 dan doesn't need change history on his side anymore
	// and we only use it for a few things while the form is open
	// so we can drop it from writes to increase efficiency on dan's side
	imp = {
		...imp,
		FormResponse: {
			...imp.FormResponse,
			StatusHistory: [],
		}
	}
	// unparse and write
	const rUnparse = safeUnparseJson(imp)
	if(rUnparse.isErr()) {
		return err(serializeFusionError('updateWorkItemImport', rUnparse.error))
	}
	const rInsert = await insertDeviceToCloudBlob({
		type: DeviceToCloudBlobType.Import,
		encounterGuid,
		fileId: null,
		upn,
		data: rUnparse.value,
		bin: false,
		nextCodeNext: null,
		contentType: null,
	})
	if(rInsert.isErr()) {
		return err(serializeFusionError('updateWorkItemImport', rInsert.error))
	}
	if(rSelectImport.value) {
		const prevImpBlob = rSelectImport.value
		const { ordinal } = prevImpBlob
		const { pendingDeviceToCloudOrdinals } = getState().sync
		// do not delete the previous draft
		// if an active sync is querying
		// or if the blob is pending in an active sync;
		// dan will just end up with both drafts in the correct sequence
		if(pendingDeviceToCloudOrdinals !== SyncDeviceToCloudOrdinalsStatus.Querying && !pendingDeviceToCloudOrdinals.includes(ordinal)) {
			const rDelete = await deleteDeviceToCloudBlob(ordinal)
			if(rDelete.isErr()) {
				return err(serializeFusionError('updateWorkItemImport', rDelete.error))
			}
		}
	}
	dispatch(dashboardDataReloadFromLdb())
	return ok()
}
